<template>
  <v-card class="pa-2" outlined tile height="100%">
    <FormDialog ref="form-dialog" @save-item="save" @update-item="update" :isAuditorRole="isAuditorRole"/>

    <v-data-table
      :headers="headers"
      :items="fluidTrackings"
      sort-by=""
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn v-if="!isAuditorRole" color="primary" dark class="mb-2" @click="show">
            New Item
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.select="{ item }">
        <router-link
          :to="{
            name: 'FTChart',
            params: { clientID: item.clientId },
            query: { ftId: item._id },
          }"
        >
          <v-btn x-small color="#2b3990" class="white--text"> select </v-btn>
        </router-link>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="viewItem(item)"> mdi-pencil </v-icon>
        <v-icon v-if="!isAuditorRole" small @click="remove(item._id)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import FormDialog from "./FormDialog";

import moment from "moment";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    FormDialog,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      headers: [
        {
          text: "Select",
          align: "start",
          value: "select",
        },
        { text: "Date", value: "date" },
        { text: "Month", value: "month" },
        { text: "Created By", value: "createdBy" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      clientId: "",
      FTid: "",
      isLoading: "",
    };
  },
  computed: {
    ...mapGetters({
      getClientFT: "fluidTracking/getClientFT",
      clientData: "clients/clientData",
    }),

    fluidTrackings() {
      const FT = this.getClientFT.map((item) => ({
        ...item,
        date: moment(item.createdAt).format("YYYY-MM-DD"),
        createdBy: `${item.createdBy} - ${new Date(item.createdAt)}`,
      }));

      return FT;
    },
    isAuditorRole() {
      return localStorage.getItem("userRole") === 'Auditor'
    }
  },

  created() {
    this.fetch();
  },

  mounted() {},
  methods: {
    ...mapActions("fluidTracking", [
      "getItemByClientId",
      "createItem",
      "updateItem",
      "deleteItem",
    ]),

    viewItem(item) {
      this.FTid = item._id;
      this.$refs["form-dialog"].populateData(item);
      this.show();
    },

    async fetch() {
      try {
        this.isLoading = true;
        this.clientId = this.$route.params.clientID;
        await this.getItemByClientId(this.clientId);
        this.isLoading = false;
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },

    async save(data) {
      try {
        await this.createItem({ ...data, clientId: this.clientId });
        this.fetch();
        this.show();
      } catch (error) {
        console.log(error);
      }
    },

    async update(data) {
      try {
        await this.updateItem({
          data: { ...data, clientId: this.clientId },
          id: this.FTid,
        });
        this.fetch();
        this.show();
      } catch (error) {
        console.log(error);
      }
    },

    async remove(id) {
      try {
        await this.deleteItem(id);
        this.fetch();
      } catch (error) {
        console.log(error);
      }
    },

    show() {
      this.$refs["form-dialog"].show();
    },
  },
};
</script>
